import { types } from '../../../constants/ActionTypes'
import { event as limit } from '../../../constants/Limit'
import { authorType, LANGUAGE_SHORT_CODE } from '../../../constants'
import { deepCopy } from '../../../lib'
import moment from 'moment'

const initialState = {
  pathname: '',
  record: undefined,
  checkedEndDatetime: false,
  authorType: authorType.CONTRIBUTOR,
  name: '',
  thumbnail: '',
  address: '',
  latitude: undefined, 
  longitude: undefined,
  addressComponents: undefined,
  startDate: moment().add(1, 'days'),
  startTime: null,
  endDate: null,
  endTime: null,
  detail: '',
}

const eventRegister = (state = initialState, action) => {
  var record, startDateTime, endDateTime
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      let params = action.payload.location.pathname.split('/')
      let regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => `^${LANGUAGE_SHORT_CODE[key]}$`).join('|')
      let pathname
      if (null !== params[1].match(`/${regstr}/`)) {
        params.splice(1,1)
        pathname = params.join('/')
      }
      else {
        pathname = action.payload.location.pathname
      }
      if (pathname === state.pathname) {
        return state
      }
      else {
        return { ...deepCopy(initialState), pathname }
      }
    case types.eventRegister.CHANGED_TEXT:
      switch (action.name) {
        case 'name':
          if (action.text.length > limit.stringLength.name) {
            return state
          }
          break
        case 'place':
          if (action.text.length > limit.stringLength.place) {
            return state
          }
          break
        case 'address':
          return { ...state, address: action.text, latitude: undefined, longitude: undefined, addressComponent: undefined }    
        default:
          break
      }
      return { ...state, [action.name]: action.text }
    case types.eventRegister.CHANGED_DATETIME:
      return { ...state, [action.name]: action.value }
    case types.eventRegister.CHANGED_GEO_CODE:
      return { ...state, addressComponents: action.geoCode.address_components }
    case types.eventRegister.CHANGED_LATLNG:
      return { ...state, latitude: action.latLng.lat, longitude: action.latLng.lng }
    case types.eventRegister.CHANGED_PHOTO:
      return { ...state, [action.name]: action.data }
    case types.eventRegister.CHANGED_CHECKBOX:
      return { ...state, [action.name]: action.check }
    case types.eventRegister.DELETE_ADDRESS:
      return { ...state, address: '', latitude: undefined, longitude: undefined, addressComponent: undefined }
    case types.eventRegister.RESPONSE_SELECT_EVENT:
      record = action.response.records[0]
      startDateTime = record.startDate ? record.startDate + (record.startTime ? record.startTime : 0) : undefined
      endDateTime = record.endDate ? record.endDate + (record.endTime ? record.endTime : 0) : undefined
      return {
        ...state,
        record,        
        checkedEndDatetime: Boolean(record.endDate !== undefined),
        authorType: record.authorType.toString(10),
        name: record.name,
        thumbnail: record.thumbnail,
        address: record.address,
        latitude: record.latitude, 
        longitude: record.longitude,
        addressComponents: record.addressComponents,
        startDate: moment(startDateTime),
        startTime: record.startTime ? moment(startDateTime) : null,
        endDate: record.endDate ? moment(endDateTime) : null,
        endTime: record.endTime ? moment(endDateTime) : null,
        detail: record.detail ? record.detail : '',
      }
    default:
      return state
  }
}

export default eventRegister


// WEBPACK FOOTER //
// ./src/reducers/Page/Event/EventRegister.js